import type { ReviewSliderContent } from '@/core/types';

import { ReviewSlider } from '@/containers/blocks/sliders';

export default function generate({
  content,
  className,
}: {
  content: ReviewSliderContent;
  className?: string;
}) {
  return (
    <ReviewSlider
      title={content.title}
      subTitle={content.subtitle}
      reviews={content.reviews}
      image={content.image}
      className={className}
    />
  );
}
